import RahuKaalMain from "@components/RahuKaalMain";

export default function RahuKaal() {
  return (
    <Container>
      <RahuKaalMain />
    </Container>
  );
}
